import { Controller } from '../utils/controller';

/**
 * tracks an element's dynamic display (usually header) to update
 * top positioning of an element. Can be extended to support different
 * properties
 */
export default class extends Controller {
  static values = {
    source: String
  };

  declare sourceValue: string;

  declare sourceNode: HTMLElement;
  declare observer: MutationObserver;
  declare sourceHeight: number;
  declare defaultTop: number;

  connect(): void | null {
    const config = { attributes: true, childList: false, subtree: false };

    if (!this.sourceValue) {
      return null;
    }

    if (!this.element.classList.contains('is-sticky')) {
      return null;
    }

    this.sourceNode = document.querySelector(this.sourceValue) as HTMLElement;
    this.sourceHeight = this.sourceNode.offsetHeight;
    this.defaultTop = this.getDefaultTopValue();
    this.observer = new MutationObserver(this.updateOnMutation);
    this.observer.observe(this.sourceNode, config);
  }

  updateOnMutation = (mutationList) => {
    for (const mutation of mutationList) {
      if (mutation.type === 'attributes') {
        this.element.style.top = this.computeNewValue(
          this.defaultTop,
          this.sourceHeight,
          parseInt(this.sourceNode.style.top)
        );
      }
    }
  };

  getDefaultTopValue = () => {
    const topProperty = this.element.computedStyleMap().get('top');
    const topValue = topProperty?.value || 0;

    return topValue;
  };

  computeNewValue(defaultTop: number, sourceHeight: number, sourceTop: number) {
    return defaultTop + sourceHeight + sourceTop + 'px';
  }

  disconnect(): void {
    this.observer.disconnect();
  }
}
